// Lightweight, cookie-free helpers shared by the click + page-view trackers.

const SESSION_KEY = "pa_session_id"

function randomId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID()
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`
}

// A per-tab session id (sessionStorage) so click events and page-view records
// from the same visit can be correlated. Not personally identifying.
export function getAnalyticsSessionId(): string | undefined {
  if (typeof window === "undefined") return undefined
  try {
    let id = window.sessionStorage.getItem(SESSION_KEY)
    if (!id) {
      id = randomId()
      window.sessionStorage.setItem(SESSION_KEY, id)
    }
    return id
  } catch {
    return undefined
  }
}

export function newViewId(): string {
  return randomId()
}

export type DeviceType = "desktop" | "tablet" | "mobile"

export function getDeviceType(): DeviceType {
  if (typeof window === "undefined") return "desktop"
  const w = window.innerWidth
  if (w < 768) return "mobile"
  if (w < 1024) return "tablet"
  return "desktop"
}
